import React, { useEffect } from "react";
import Heading from "../../../ui/components/heading/Heading.tsx";
import SubtitleTypeA from "../../../ui/components/subtitle-type-a/SubtitleTypeA.tsx";
import Sectors, { ISectorCard } from "../../../components/sectors/Sectors.tsx";
import roadImage from "../../../media/sectors/road.webp";
import truckImage from "../../../media/sectors/truck.webp";
import countingImage from "../../../media/sectors/counting.webp";
import piggyBankImage from "../../../media/sectors/piggy-bank.webp";
import radioTowerImage from "../../../media/sectors/radio-tower.webp";
import { useTranslation } from "react-i18next";
import Industries from "../../software-development/industries/Industries.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";

const TechSolutions = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sectorCards: ISectorCard[] = [
    {
      image: truckImage,
      title: t("expertiseSectors.logistics.title"),
      text: t("expertiseSectors.logistics.description"),
      id: 2,
      link: "/services/logistics-and-supply-chains",
    },
    {
      image: countingImage,
      title: t("expertiseSectors.utilitiesServices.title"),
      text: t("expertiseSectors.utilitiesServices.description"),
      id: 3,
    },
    {
      image: piggyBankImage,
      title: t("expertiseSectors.financeAndBanking.title"),
      text: t("expertiseSectors.financeAndBanking.description"),
      id: 4,
    },
    {
      image: radioTowerImage,
      title: t("expertiseSectors.telecommunications.title"),
      text: t("expertiseSectors.telecommunications.description"),
      id: 5,
    },
    {
      image: roadImage,
      title: t("expertiseSectors.roadEngineering.title"),
      text: t("expertiseSectors.roadEngineering.description"),
      id: 6,
    },
  ];

  return (
    <main>
      <Heading
        startRowText={t("industriesPage.startRowText")}
        middleRowText={t("industriesPage.middleRowText")}
        endRowText={t("industriesPage.endRowText")}
        message={t("solutionsViewAll.text")}
        buttonText={t("solutionsViewAll.buttonText")}
      />

      <section className="section--white" id="nav-dark">
        <SubtitleTypeA
          title={t("solutionsViewAll.subtitleTypeA")}
          text={t("solutionsViewAll.subtitleTypeAText")}
        />
        <Sectors title={t("expertiseSectors.title")} cards={sectorCards} />
      </section>
      <Industries
        title={t("solutionsViewAll.industries")}
        subtitle={t("solutionsViewAll.industriesText")}
      />
      <section className="section--white" id="nav-dark">
        <FormCard />
      </section>
    </main>
  );
};

export default TechSolutions;
